"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = generatePicker;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var React = _interopRequireWildcard(require("react"));
var _ = require(".");
var _Icon = _interopRequireDefault(require("../Icon"));
var _picker2 = _interopRequireDefault(require("./picker"));
var _rangePicker = _interopRequireDefault(require("./rangePicker"));
var _dateInput = _interopRequireDefault(require("./inputs/dateInput"));
var _inputHOC = _interopRequireDefault(require("../Form/inputHOC"));
var _LocaleContext = require("../locales/LocaleContext");
var _default = _interopRequireDefault(require("../locales/default"));
require("moment/locale/tr");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _excluded = ["bordered", "format", "showTime"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function generatePicker() {
  var getPicker = function getPicker(_picker) {
    var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Datepicker';
    return function (InputComponent) {
      var Picker = /*#__PURE__*/function (_React$Component) {
        function Picker() {
          (0, _classCallCheck2.default)(this, Picker);
          return _callSuper(this, Picker, arguments);
        }
        (0, _inherits2.default)(Picker, _React$Component);
        return (0, _createClass2.default)(Picker, [{
          key: "render",
          value: function render() {
            var _this$props = this.props,
              _this$props$bordered = _this$props.bordered,
              bordered = _this$props$bordered === void 0 ? true : _this$props$bordered,
              format = _this$props.format,
              showTime = _this$props.showTime,
              restProps = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
            var picker = restProps.picker || _picker;
            if (picker == 'range') {
              picker = undefined;
            }
            delete restProps.picker;
            var additionalProps = {};
            if (displayName !== 'RangePicker') {
              additionalProps.showToday = true;
            }
            var additionalOverrideProps = {
              showTime: showTime,
              picker: picker
            };
            additionalOverrideProps = _objectSpread(_objectSpread(_objectSpread({}, additionalOverrideProps), showTime ? (0, _.getTimeProps)(_objectSpread({
              format: format,
              picker: picker
            }, showTime)) : {
              format: format
            }), picker === 'time' ? (0, _.getTimeProps)(_objectSpread(_objectSpread({
              format: format
            }, this.props), {}, {
              picker: picker
            })) : {
              format: format
            });
            return /*#__PURE__*/React.createElement(_LocaleContext.LocaleReceiver, {
              componentName: "DatePicker",
              defaultLocale: _default.default.DatePicker
            }, function (localeCode, locale) {
              return /*#__PURE__*/React.createElement(InputComponent, (0, _extends2.default)({
                allowClear: true
              }, additionalProps, restProps, additionalOverrideProps, {
                locale: locale
              }));
            });
          }
        }]);
      }(React.Component);
      if (displayName) {
        Picker.displayName = displayName;
      }
      // return Picker;
      return (0, _inputHOC.default)(Picker);
    };
  };
  var DatePicker = getPicker()((0, _picker2.default)(_dateInput.default));
  var WeekPicker = getPicker('week', 'WeekPicker')((0, _picker2.default)(_dateInput.default));
  var MonthPicker = getPicker('month', 'MonthPicker')((0, _picker2.default)(_dateInput.default));
  var YearPicker = getPicker('year', 'YearPicker')((0, _picker2.default)(_dateInput.default));
  var TimePicker = getPicker('time', 'TimePicker')((0, _picker2.default)(_dateInput.default));
  var RangePicker = getPicker('range', 'RangePicker')((0, _rangePicker.default)(_dateInput.default));
  var MergedDatePicker = DatePicker;
  MergedDatePicker.WeekPicker = WeekPicker;
  MergedDatePicker.MonthPicker = MonthPicker;
  MergedDatePicker.YearPicker = YearPicker;
  MergedDatePicker.RangePicker = RangePicker;
  MergedDatePicker.TimePicker = TimePicker;
  DatePicker.propTypes = {
    localeCode: _propTypes.default.string,
    disabled: _propTypes.default.bool,
    showTime: _propTypes.default.bool,
    onChange: _propTypes.default.func,
    onBlur: _propTypes.default.func,
    disabledDate: _propTypes.default.func,
    disabledTime: _propTypes.default.func,
    showToday: _propTypes.default.bool,
    okButtonText: _propTypes.default.string,
    /**
     * Additional CSS ui classes
     */
    className: _propTypes.default.string,
    children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
    defaultValue: _propTypes.default.object,
    allowClear: _propTypes.default.bool,
    allowInputChange: _propTypes.default.bool,
    inputProps: _propTypes.default.object,
    /**
     * placeholder
     */
    placeholder: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
      // range picer
      startDate: _propTypes.default.string,
      endDate: _propTypes.default.string,
      // range time picker
      startTime: _propTypes.default.string,
      endTime: _propTypes.default.string
    })]),
    format: _propTypes.default.string
  };
  DatePicker.defaultProps = {
    disabled: false,
    showTime: false,
    allowClear: false,
    showToday: true,
    showFooter: true,
    allowInputChange: true,
    inputProps: {}
  };
  return MergedDatePicker;
}